import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  body {
    margin: 0;
    padding: 0
  }

  @media only screen and (max-width: 767.99px) {
    .ant-layout {
      position: relative;
      overflow: hidden;
      min-width: 100vw;
    }

    .ant-layout-sider-zero-width-trigger-left {
      display: none !important;
    }
  }
`;
